import { useTranslation } from '@mc/i18n'
import { Locations } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavClick } from 'components/Navigation/events'
import { masterclassPath } from 'libs/paths'

export const MasterClassLink = ({
  className = '',
  location = Locations.NAVIGATION,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.masterClass')

  const handleMasterClassClick = () => {
    trackNavClick(ctaCopy, undefined, location)()
  }

  return (
    <Link
      href={masterclassPath()}
      className={className}
      onClick={handleMasterClassClick}
      passHref
    >
      {ctaCopy}
    </Link>
  )
}
